export const reasonParams = [
  {
    reasonCode: "FE1",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE2",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE3",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE4",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: false
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE5",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: false
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE6",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE7",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE8",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE9",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE10",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE11",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE12",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE13",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE14",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FE15",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Cliente"
    },
    vatCompetencePeriod: {
      visible: false
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA1",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA2",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA3",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA4",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA5",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA6",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA7",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA8",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA9",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA10",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA11",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA12",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "FA13",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: true,
      disabled: true
    },
    sectional: {
      visible: true,
      disabled: true
    },
    docNumber: {
      visible: true,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: true,
      disabled: true
    },
    supplier: {
      visible: true,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: true
    }
  },
  {
    reasonCode: "PF1",
    registrationDate: {
      visible: true,
      disabled: false
    },
    amount: {
      visible: false,
      disabled: true
    },
    sectional: {
      visible: false,
      disabled: true
    },
    docNumber: {
      visible: false,
      disabled: true
    },
    docDate: {
      visible: true,
      disabled: true
    },
    sdiCode: {
      visible: false,
      disabled: true
    },
    supplier: {
      visible: false,
      type: "Fornitore"
    },
    vatCompetencePeriod: {
      visible: true
    },
    vatLines: {
      visible: false
    }
  }
];
